var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled, { css, useTheme } from '@xstyled/styled-components';
import { th } from '@xstyled/styled-components';
import { useMemo } from 'react';
var Circle = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  min-width: 12px;\n  display: flex;\n  align-items: center;\n  height: ", ";\n  padding: ", ";\n  color: white;\n  gap: 10px;\n  background-color: ", ";\n  border-radius: 29px;\n  line-height: 15.6px;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: semiBold;\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  z-index: 1;\n"], ["\n  min-width: 12px;\n  display: flex;\n  align-items: center;\n  height: ", ";\n  padding: ", ";\n  color: white;\n  gap: 10px;\n  background-color: ", ";\n  border-radius: 29px;\n  line-height: 15.6px;\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: semiBold;\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  z-index: 1;\n"])), function (_a) {
    var size = _a.size;
    return (size === 'small' ? '16px' : '24px');
}, function (_a) {
    var size = _a.size;
    return (size === 'small' ? '0 5px' : '3px 8px');
}, function (_a) {
    var color = _a.color;
    return color;
}, th('fonts.primary'), function (_a) {
    var size = _a.size;
    return (size === 'small' ? '12px' : '14px');
}, function (_a) {
    var topPosition = _a.topPosition;
    return topPosition && '-15%';
}, function (_a) {
    var horizontalPosition = _a.horizontalPosition;
    return (horizontalPosition === 'middle' ? '50%' : '100%');
});
var RelativeWrap = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  ", ";\n"], ["\n  position: relative;\n  ", ";\n"])), function (_a) {
    var width = _a.width;
    return width
        ? css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n          width: ", ";\n        "], ["\n          width: ", ";\n        "])), width) : '';
});
var Badge = function (_a) {
    var children = _a.children, _b = _a.color, color = _b === void 0 ? 'red1' : _b, _c = _a.size, size = _c === void 0 ? 'default' : _c, label = _a.label, childWidth = _a.childWidth, topPosition = _a.topPosition, _d = _a.horizontalPosition, horizontalPosition = _d === void 0 ? 'middle' : _d;
    var theme = useTheme();
    var themeColor = th.color(color)({ theme: theme });
    var badgeLabel = useMemo(function () {
        return typeof label === 'number' ? (label >= 100 ? '99+' : label) : label;
    }, [label]);
    if (!label || (typeof label === 'number' && label <= 0)) {
        return _jsx(_Fragment, { children: children });
    }
    return (_jsxs(RelativeWrap, { width: childWidth, children: [_jsx(Circle, { color: themeColor, size: size, topPosition: topPosition, horizontalPosition: horizontalPosition, children: _jsx("div", { className: "label", children: badgeLabel }) }), children] }));
};
export default Badge;
var templateObject_1, templateObject_2, templateObject_3;
